import React from 'react';
import { useLocation } from 'react-router-dom';
import { Card, Container, Alert } from 'react-bootstrap';

const NPSErrorPage = () => {
  const location = useLocation();
  const errorMessage = location.state?.message || 'Une erreur est survenue.';

  return (
    <Container className="d-flex align-items-center justify-content-center min-vh-100">
      <Card className="text-center shadow" style={{ maxWidth: '600px', width: '100%' }}>
        <Card.Body className="p-5">
          {/* Logo */}
          <div className="mb-4">
            <img
              src="https://img.mailinblue.com/7320067/images/content_library/original/662637fb2a1bc1605466bed0.png"
              alt="Marion"
              style={{ maxWidth: '150px' }}
            />
          </div>

          {/* Error Icon */}
          <div className="mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center text-white mb-3 animate-scale-in"
              style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                backgroundColor: '#ffc107',
                fontSize: '50px',
                fontWeight: 'bold'
              }}
            >
              !
            </div>
          </div>

          {/* Error Message */}
          <h2 className="mb-3">Oups !</h2>

          <Alert variant="warning">
            {errorMessage}
          </Alert>

          <p className="text-muted mb-4">
            Si tu penses qu'il s'agit d'une erreur, n'hésite pas à nous contacter.
          </p>

          {/* Footer */}
          <div className="mt-5 pt-4" style={{ borderTop: '1px solid #e0e0e0', fontSize: '14px', color: '#999' }}>
            <p className="mb-1"><strong>Marion</strong></p>
            <p className="mb-0">559 CHE DU HAMEAU DE PLAN SARRAIN, 06370, MOUANS-SARTOUX</p>
          </div>
        </Card.Body>
      </Card>

      <style>{`
        @keyframes scaleIn {
          from {
            transform: scale(0);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
        .animate-scale-in {
          animation: scaleIn 0.5s ease-out;
        }
      `}</style>
    </Container>
  );
};

export default NPSErrorPage;
